<div class="interview-agent-v2-transcript-section">
  <!-- Header -->
  <div class="transcript-section-top-header">
    Transcription
    <hr *ngIf="false" />
    <div class="fade-rect"></div>
  </div>

  <!-- Transcript list -->
  <div
    class="main-transcript-section"
    *ngIf="!hide"
    [class.maximized]="isMaximized"
    [class.processing-loader-visible]="showDocumentLoader"
  >
    <div *ngIf="showDocumentLoader" class="transcript-processing-loader">
      <img [src]="loaderLogoSrc" alt="IQIGai Logo" />
    </div>

    <div
      *ngFor="let item of transcriptsArray; trackBy: trackByTranscriptId"
      class="chat-wrapper"
      [ngClass]="{
        user: item?.role === 'user' || item?.attachment?.uploadedFile,
        assistant: item?.role === 'assistant' || item?.downloadPdf,
      }"
    >
      <!-- Text chat -->
      <div
        *ngIf="item?.role === 'user' || item?.role === 'assistant'"
        class="chat-cloud"
        [ngClass]="{
          preview: item?.previewMarkDown,
          suggestion: item?.type === 'SUGGESTION',
        }"
      >
        <markdown
          [data]="item?.previewMarkDown || item?.text"
          class="markdown-content-interview"
        ></markdown>
        <p *ngIf="item?.type === 'SUGGESTION'" class="suggested-mark">
          Suggested
        </p>
      </div>

      <!-- Uploaded PDF -->
      <div
        *ngIf="item?.attachment?.uploadedFile"
        class="chat-cloud download-pdf cursor-pointer"
        title="Click to open pdf in full screen view"
        (click)="openPdfInFullView(item?.attachment?.url)"
      >
        Uploaded Job Description
        <div class="embed-wrapper">
          <iframe
            [src]="item.safeUploadedUrl"
            width="100%"
            height="300px"
            style="border: none"
          >
          </iframe>

          <div class="clicker-overlay"></div>
        </div>
      </div>

      <!-- Downloadable PDF -->
      <div
        *ngIf="item?.downloadPdf"
        class="chat-cloud download-pdf cursor-pointer mt-4"
        title="Click to open pdf in full screen view"
        (click)="openPdfInFullView(item?.downloadPdf)"
      >
        Download Final Job Description
        <div class="embed-wrapper">
          <iframe
            [src]="item.safeDownloadUrl"
            width="100%"
            height="300px"
            style="border: none"
          >
          </iframe>

          <div class="clicker-overlay"></div>
        </div>
        <span
          class="download-pdf-btn"
          (click)="$event.stopPropagation(); onDownloadUrl(item?.downloadPdf)"
        >
          Download
        </span>
      </div>

      <!-- <div *ngIf="item?.searchedResumesMatches?.length" class="chat-cloud">
        <div class="resumes-table-wrapper">
          <table class="resumes-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Matching Score</th>
                <th>Summary</th>
                <th>Profile</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let resume of item.searchedResumesMatches">
                <td>
                  <div>
                    <div>{{ resume.candidate_name }}</div>
                    <div>{{ resume.department }}</div>
                  </div>
                </td>

                <td>{{ resume.score * 100 | number: "1.0-0" }}%</td>

                <td>
                  {{ resume.summary || "No summary available." }}
                </td>

                <td>
                  <button (click)="handleGoToProfileClicked(resume)">
                    Go to profile
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div> -->
    </div>
  </div>

  <!-- Input -->
  <div *ngIf="!hideInput" class="input-section" [class.hide]="hide">
    <input
      #inputRef
      [(ngModel)]="textValue"
      type="text"
      placeholder="Type your answer"
      (keydown.enter)="sendMessage()"
    />
    <div
      class="submit-btn"
      [class.disabled]="!textValue"
      (click)="sendMessage()"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="9"
        height="5"
        viewBox="0 0 9 5"
        fill="none"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M4.22485 0.142346L0.239014 4.36619L0.765928 4.92371L4.22485 1.25822L7.68304 4.92371L8.20902 4.36619L4.22485 0.142346Z"
          fill="var(--card_number_color)"
        />
      </svg>
    </div>
  </div>

  <!-- Transcript turned off -->
  <div *ngIf="hide" class="transcript-turned-off-message">
    Transcript was turned off
  </div>

  <!-- Full screen PDF viewer -->
<div
  *ngIf="fullViewFile"
  class="full-screen-view"
  (click)="fullViewFile = null"
>
  <iframe
    [src]="fullViewFile"
    (click)="$event.stopPropagation()"
  ></iframe>

  <span
    class="cross-icon"
    (click)="closeFullView($event)"
  ></span>
</div>

</div>
